export default __webpack_public_path__ + "static/media/03.5e8cc459.jpg";